<!-- <div bsModal #content="bs-modal" class="modal fade {{hiddenModal ? 'hidden' : ''}}" tabindex="-1"
     [config]="{backdrop: 'static', ignoreBackdropClick: true}" role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content"> -->
      <div class="modal-header">
        <div class="col-md-9">
          <h4 class="col-md-12 modal-title pull-left pl-0">New Rental Income</h4>
          <h6 class="col-md-12 modal-title pull-left pl-0">{{properties.property_address}}</h6>
        </div>
        <div class="col-md-3 d-flex">
          <!-- <a class="text-danger font-weight-bold cursor-pointer mr-2 mt-1 " style="font-size: 12px!important; color: #254a69;" href="javaScript:void(0)" (click)="openReportNewIssueModal('add-new-rent')">Report an Issue </a> -->
          <button type="button" class="close" aria-label="Close" (click)="closeModel()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <form class="form" [formGroup]="rentalForm" novalidate>
        <div class="modal-body pt-2">
          <div class="row">
            <!-- <div class="col-md-12 col-sm-12 pl-0 pr-0"> -->
              <!-- <button *ngIf="!isEdit" type="button" (click)="addNewRow('','','','')"
                      class="btn btn-primary btn-xs pull-right mb-3"><span class="pl-2 pr-1">New
                    Rent Row</span></button>
            </div> -->

            <div class="col-md-12 col-sm-12 text-small table-responsive" style="padding-bottom: 250px;">
              <table class="table table-bordered mb-0">
                <thead class="thead-light">
                <tr>
                  <th scope="col" style="min-width: 140px;">Paid Date</th>
                  <th scope="col" style="min-width: 180px;">Rent Payment (Gross)</th>
                  <th scope="col" style="min-width: 160px;">Tenant Name</th>
                  <th scope="col" style="width: 80px; text-align: center;">Attachment</th>
                </tr>
                </thead>
                <tbody formArrayName="dataArray">
                  <ng-container *ngFor="let row of dataArray.controls; let key = index" [formGroupName]="key">
                    <tr>
                      <td class="align-middle" style="min-width: 140px;">
                        <label class="form-group has-float-label mb-0">
                          <div class="input-group">
                            <input class="form-control" placeholder="dd/mm/yyyy"
                                   formControlName="date_s"
                                   ngbDatepicker #rent_paid_date="ngbDatepicker"
                                   (click)="rent_paid_date.toggle()" 
                                   (ngModelChange)="validateField(row, $event)">
                          </div>
                          <div *ngIf="row.get('date_s').invalid && (row.get('date_s').dirty || row.get('date_s').touched)" class="invalid-tooltip">This field is required</div>
                        </label>
                      </td>
                      <td class="align-middle" style="min-width: 180px;">
                        <label class="form-group has-float-label has-left-icon-append mb-0">
                          <div class="input-group">
                            <div class="input-group-prepend custom-input-group-append-icon-right-border">
                              <span class="input-group-text custom-input-group-append-icon ">$</span>
                            </div>
                            <input type="number" class="form-control" aria-describedby="inputGroup-sizing-sm"
                                   formControlName="amount"
                                   (blur)="amountChange(key, row.value.amount)" 
                                   (ngModelChange)="validateAmount(row, $event)">
                          </div>
                          <div *ngIf="row.get('amount').invalid && (row.get('amount').dirty || row.get('amount').touched)" class="invalid-tooltip">This field is required</div>
                        </label>
                      </td>
                      <td class="align-middle" style="min-width: 160px;">
                        <label class="form-group has-float-label mb-0">
                          <div class="position-relative has-icon-left">
                            <div class="input-group">
                              <input type="text" class="form-control" aria-describedby="inputGroup-sizing-sm"
                                     formControlName="name"
                                     (blur)="tenantChange(key, row.value.name)">
                            </div>
                          </div>
                        </label>
                      </td>
                      <td class="align-middle text-center" style="width: 80px;">
                        <div class="table-dropzone overflow-unset" ngx-dropzone [accept]="'.pdf'" #drop1
                             (change)="savePdfs($event,'row_pdf',key)" hidden>
                          <ngx-dropzone-label>
                            <div>
                              <i class="fa fa-plus"></i>
                            </div>
                          </ngx-dropzone-label>
                        </div>
                        <div class="row">
                          <div class="form-group pr-2 pt-2 d-flex">
                            <a href="javascript:;" class="badge badge-warning mb-1 mr-1" ngbTooltip="Browse File" (click)="drop1.showFileSelector()">
                              <i class="glyph-icon simple-icon-paper-clip f-15"></i>
                            </a>
                            <!-- <a *ngIf="dataArray.length > 1" href="javascript:;" class="badge badge-primary mb-1 mr-1" ngbTooltip="Add Row" (click)="addRow(key,row)">
                              <i class="fa fa-plus f-15" style="font-weight: 500;"></i> -->
                            <!-- </a> -->
                            <!-- <a *ngIf="dataArray.length > 0" href="javascript:;" class="badge badge-danger mb-1 mr-1" ngbTooltip="Delete" (click)="removeRecord(row.value.randomStr)">
                              <i class="glyph-icon simple-icon-trash f-15"></i>
                            </a> -->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="row.get('media').value.length != 0">
                      <td colspan="4" class="pb-2 pt-2">
                        <div class="row">
                          <ng-container *ngFor="let media of row.get('media').value; let key_media = index">
                            <div class="col-md-3" *ngIf="media.full_url!=''">
                              <a class="cursor-pointer " tooltip="{{media.file_name}}">
                                <span class="f-11" (click)="mediaDownload(media)">{{ media.file_name | slice:0:20 }}</span>
                                <span *ngIf="media['file_name'].length >20 ">...</span> 
                                <i class="fa fa-remove text-danger ml-2" (click)="removePdfRental(key,media.file_name,key_media)"></i>
                              </a>
                            </div>
                          </ng-container>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <input type="hidden" formControlName="rental_detail_ref" /> -->
          <input type="hidden" formControlName="property_ref" />
        </div>
        <div class="modal-footer" style="display: block !important;">
          <div class="row">
            <!-- <div class="col-md-5 pull-left">
              <button *ngIf="showMissingBtn" type="button" class="btn btn-outline-secondary btn-xs pull-left mb-2"
                      (click)="createMissingRentals(content)">Create Missing Rents</button>
            </div> -->
            
            <div class="col-md-12 pull-right">
               <button type="button" class="btn btn-outline-secondary btn-xs pull-right mb-2  mr-2"
                      (click)="closeModel()">Close</button>
              <app-state-button btnClass="btn btn-primary btn-xs pull-right mb-2" [currentState]="responseWaiting" message="false"
                                (click)="addNewRentalDetailSubmit(content)" [isDisabled]="buttonDisabled">Save
              </app-state-button>
             
              <!-- <app-state-button btnClass="btn btn-primary btn-xs pull-right mr-2 mb-2" [currentState]="responseWaiting1" message="false"
                                (click)="addNewRentalDetailCreateExpensesSubmit(content)" [isDisabled]="buttonDisabled1">Save & Create Expenses
              </app-state-button> -->
            </div>
          </div>
        </div>
      </form>
    <!-- </div>
  </div>
</div> -->
